import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { Controller } from 'react-hook-form';

const autocompleteStyle = {
  '.MuiOutlinedInput-root': {
    padding: '3px'
  },
  '.MuiAutocomplete-popupIndicator': {
    height: '30px'
  },
  '.MuiAutocomplete-clearIndicator': {
    height: '30px'
  }
};

const TimezoneSelector = ({ name, control, rules, disabled = false }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTimezones = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_AWS_S3_BASE_URL}/timezones.json`);
        const data = response.data;

        // Format the options for display
        const formattedOptions = data.map((item) => ({
          label: `(GMT${Number(item['UTC Offset (Hours)']?.split(':')?.join('.')) >= 0 ? '+' : '-'}${item['UTC Offset (Hours)']?.replace(
            '-',
            ''
          )}) ${item.City}`,
          value: item.Timezone,
          searchKey: `${item.City.toLowerCase()} ${item['UTC Offset (Hours)']}` // For searching
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error('Error fetching timezones:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTimezones();
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <Autocomplete
          sx={autocompleteStyle}
          options={options}
          getOptionLabel={(option) => option.label}
          filterOptions={(options, { inputValue }) => options.filter((option) => option.searchKey.includes(inputValue.toLowerCase()))}
          value={options.find((option) => option.value === field.value) || null}
          onChange={(event, newValue) => field.onChange(newValue ? newValue.value : null)}
          loading={loading}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              // label="Select Timezone"
              placeholder="Select Timezone"
              variant="outlined"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress
                        color="inherit"
                        size={10}
                      />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      )}
    />
  );
};

export default TimezoneSelector;
